const moment = require('moment')
require('moment/locale/pt-br')

export const defaultFilters = () => [
	{
		component: 'datepicker-range',
		name: 'data_de_criacao',
		label: 'Data de Criação',
		disabled: false,
		hidden: false,
		style: 'form-sale-dates',
		preSelected: ['reports'], //define aonde será preselecionado um valor padrão
		maxDate: moment().subtract(1, 'days').format('YYYY-MM-DD'),
		params: {
			name: 'created_at',
			value: null,
		},
	},
	{
		component: 'datepicker-range',
		name: 'data_de_atualizacao',
		label: 'Data de Atualização',
		disabled: false,
		hidden: false,
		style: 'form-sale-dates',
		maxDate: moment().subtract(1, 'days').format('YYYY-MM-DD'),
		params: {
			name: 'updated_at',
			value: null,
		},
	},
	{
		component: 'datepicker-range',
		name: 'data_de_vendas',
		label: 'Data de Venda',
		disabled: false,
		hidden: false,
		style: 'form-sale-dates',
		maxDate: moment().subtract(1, 'days').format('YYYY-MM-DD'),
		params: {
			name: 'saled_at',
			value: null,
		},
	},
	{
		component: 'datepicker-range',
		name: 'data_de_movimentacao_etapa',
		label: 'Data de Movimentação Etapa',
		disabled: false,
		hidden: false,
		style: 'form-sale-dates',
		maxDate: moment().subtract(1, 'days').format('YYYY-MM-DD'),
		params: {
			name: 'created_at',
			value: null,
		},
	},
	{
		component: 'select-tags',
		name: 'canal',
		ajaxSearch: false,
		label: "Canal",
		disabled: false,
		hidden: false,
		handler: 'inputHandler',
		service: 'channels',
		method: 'getAllV2',
		itemLabel: 'label',
		searchAble: true,
		multiple: true,
		options: [],
		groupBy: 'type',
		returnValue: 'id',
		serviceParams: '?per_page=1000&page=1',
		searchEvent: 'channel-next-event',
		params: {
			name: 'channel_id',
			value: null
		},
		requestOnStart: false,
		alreadyRequested: false,
		loading: false,
		openEvent: 'kanban-filter-channel'
	},
	{
		component: 'select-tags',
		name: 'contratos',
		label: 'Contratos',
		disabled: false,
		hidden: false,
		handler: null,
		service: 'contractGeneration',
		method: 'getAll',
		itemLabel: 'name',
		searchAble: true,
		multiple: true,
		serviceParams: null,
		options: [],
		returnValue: 'id',
		params: {
			name: null,
			value: null,
		},
		requestOnStart: false,
		alreadyRequested: false,
		loading: false,
	},
	{
		component: 'select-tags',
		name: 'clientes',
		label: 'Clientes',
		disabled: false,
		hidden: false,
		handler: null,
		service: 'customer',
		method: 'getData',
		itemLabel: 'name',
		searchAble: true,
		multiple: true,
		serviceParams: 'per_page=800&page=1',
		options: [],
		returnValue: 'id_customer',
		params: {
			name: null,
			value: null,
		},
		requestOnStart: false,
		alreadyRequested: false,
		loading: false,
	},
	{
		component: 'select-tags',
		name: 'resposavel',
		label: 'Responsável',
		disabled: false,
		hidden: false,
		itemLabel: 'item',
		searchAble: true,
		multiple: true,
		options: [
			{ item: 'Todos', value: 'allDeals', id: 0 },
			{ item: 'Meus Clientes', value: 'myDeals', id: 1 },
			{ item: 'Acompanhando', value: 'followingDeals', id: 2 },
			{ item: 'Não Atribuídos', value: 'notAssigned', id: 3 },
		],
		returnValue: 'value',
		params: {
			name: 'owner',
			value: null,
		},
		requestOnStart: false,
		alreadyRequested: false,
		loading: false,
	},
	{
		component: 'select-tags',
		name: 'tipo_de_entrada_do_lead',
		label: 'Tipo de Entrada do Lead',
		disabled: false,
		hidden: false,
		handler: 'leadEntryHandler',
		itemLabel: 'item',
		searchAble: true,
		multiple: true,
		options: [
			{ item: 'Integração', value: 'Integração', id: 0 },
			{ item: 'Manual', value: 'Manual', id: 1 },
		],
		returnValue: 'value',
		params: {
			name: 'lead_entry_type',
			value: null,
		},
		requestOnStart: false,
		alreadyRequested: false,
		loading: false,
	},
	{
		component: 'select-tags',
		name: 'fila_de_distribuicao_de_leads',
		label: "Fila de Distribuição de Leads",
		disabled: false,
		hidden: false,
		handler: 'leadHandler',
		service: 'lead',
		method: 'getAll',
		itemLabel: 'name',
		searchAble: true,
		multiple: true,
		options: [],
		returnValue: 'id',
		params: {
			name: 'lead_id',
			value: null
		},
		requestOnStart: false,
		alreadyRequested: false,
		loading: false,
	},
	{
		component: 'select-tags',
		name: 'status_do_lead',
		label: 'Status do Lead',
		disabled: false,
		hidden: false,
		handler: 'leadStatusHandler',
		itemLabel: 'item',
		searchAble: true,
		multiple: true,
		options: [
			{ item: 'Disponível', value: 'Disponível', id: 0 },
			{ item: 'Indisponível', value: 'Indisponível', id: 1 },
			{ item: 'Qualificado', value: 'Qualificado', id: 2 },
			{ item: 'Desqualificado', value: 'Desqualificado', id: 3 },
		],
		returnValue: 'value',
		params: {
			name: null,
			value: null,
		},
		requestOnStart: false,
		alreadyRequested: false,
		loading: false,
	},
	{
		component: 'select-tags',
		name: 'erp',
		label: 'ERP',
		disabled: false,
		hidden: false,
		handler: null,
		service: 'erp',
		method: 'getAll',
		itemLabel: 'type',
		searchAble: true,
		multiple: true,
		serviceParams: null,
		options: [],
		returnValue: 'id',
		params: {
			name: null,
			value: null,
		},
		requestOnStart: false,
		alreadyRequested: false,
		loading: false,
	},
	{
		component: 'select-tags',
		name: 'ociosidade',
		label: 'Ociosidade',
		disabled: true,
		hidden: false,
		service: 'idle',
		method: 'getAllV2',
		itemLabel: 'name',
		returnValue: 'id',
		searchAble: false,
		multiple: true,
		parse(data) {
			if (data && data.data) {
				return Object.values(data.data).map((option) => {
					let idle = option
					idle.stage = option.stage && option.stage.name ? option.stage.name : 'Regras atuais'
					idle.status = option.status && option.status.name ? option.status.name : 'Sem status'

					return idle
				})
			}
			return []
		},
		options: [],
		groupBy: 'stage',
		params: {
			name: 'idle_color_v2',
			value: null,
		},
		requestOnStart: false,
		alreadyRequested: false,
		loading: false,
	},
	{
		component: 'select-tags',
		name: 'lancamentos',
		label: "Lançamentos",
		disabled: false,
		hidden: false,
		service: 'launchDay',
		method: 'getAll',
		itemLabel: 'name',
		searchAble: true,
		multiple: true,
		serviceParams: [],
		options: [],
		returnValue: 'id',
		params: {
			name: null,
			value: null
		},
		requestOnStart: false,
		alreadyRequested: false,
		loading: false,
	},
	{
		component: 'select-tags',
		name: 'novidades',
		label: "Novidades",
		disabled: false,
		hidden: false,
		service: 'novelty',
		method: 'getData',
		itemLabel: 'name',
		searchAble: true,
		multiple: true,
		serviceParams: [],
		options: [],
		returnValue: 'id',
		params: {
			name: null,
			value: null
		},
		requestOnStart: false,
		alreadyRequested: false,
		loading: false,
	},
	{
		component: 'select-tags',
		name: 'origens',
		label: "Origens",
		disabled: false,
		hidden: false,
		handler: 'inputHandler',
		service: 'origins',
		method: 'getOrigins',
		itemLabel: 'label',
		searchAble: true,
		multiple: true,
		serviceParams: [],
		options: [],
		returnValue: 'id',
		groupBy: 'type',
		params: {
			name: 'origin_id',
			value: null
		},
		requestOnStart: false,
		alreadyRequested: false,
		loading: false,
		openEvent: 'kanban-filter-origens'
	},
	{
		component: 'select-tags',
		name: 'empreendimentos',
		label: "Empreendimentos",
		disabled: false,
		hidden: false,
		handler: 'inputHandler',
		service: 'product',
		itemLabel: 'label',
		searchAble: true,
		multiple: true,
		method: 'getProductOptions',
		options: [],
		returnValue: 'id',
		params: {
			name: 'product_id',
			value: null
		},
		requestOnStart: false,
		alreadyRequested: false,
		loading: false,
	},
	{
		component: 'select-tags',
		name: 'tags',
		label: "Tags",
		disabled: false,
		hidden: false,
		service: 'tag',
		method: 'getTagOptions',
		itemLabel: 'label',
		searchAble: true,
		multiple: true,
		serviceParams: ['tags'],
		options: [],
		groupBy: 'type',
		returnValue: 'label',
		params: {
			name: 'tags',
			value: null
		},
		requestOnStart: false,
		alreadyRequested: false,
		loading: false,
		openEvent: 'kanban-filter-tags',
	},
	{
		component: 'select-tags',
		name: 'tarefa',
		label: 'Tarefa',
		disabled: false,
		hidden: false,
		load: false,
		itemLabel: 'item',
		searchAble: false,
		multiple: true,
		model: '',
		returnValue: 'value',
		options: [
            { item: 'Todos', value: 2, id: 0 },
            { item: 'Com Tarefas Ativas', value: 1, id: 1 },
            { item: 'Com Tarefas Atrasadas', value: -1, id: 2 },
            { item: 'Sem Tarefas', value: 3, id: 3 }
		],
		params: {
			name: 'tasks',
			value: null,
		},
		requestOnStart: false,
		alreadyRequested: false,
		loading: false,
	},
	{
		component: 'select-tags',
		name: 'etapa',
		label: "Etapa",
		disabled: false,
		hidden: false,
		handler: 'stageHandler',
		service: 'funnel',
		method: 'getStages',
		itemLabel: 'name',
		searchAble: false,
		multiple: true,
		options: [],
		returnValue: 'id',
		params: {
			name: 'funnel_stage_id',
			value: null
		},
		requestOnStart: true,
		alreadyRequested: false,
		loading: false,
	},
	{
		component: 'select-tags',
		name: 'status',
		label: 'Status',
		disabled: true,
		hidden: false,
		handler: 'statusHandler',
		itemLabel: 'name',
		searchAble: true,
		multiple: true,
		options: [],
		returnValue: 'id',
		groupBy: 'funnel_stage_name',
		params: {
			name: 'funnel_stage_status_id',
			value: null,
		},
		requestOnStart: false,
		alreadyRequested: false,
		loading: false,
	},
	{
		component: 'select-tags',
		name: 'queue_id',
		label: 'Oferta Ativa',
		disabled: false,
		hidden: false,
		handler: 'queuesHandler',
		service: 'activeOffer',
		method: 'getAllQueues',
		itemLabel: 'name',
		searchAble: true,
		multiple: false,
		options: [],
		returnValue: 'id',
		params: {
			name: 'queue_id',
			value: null,
		},
		serviceParams: null,
		requestOnStart: true,
		alreadyRequested: false,
		loading: false,
	},
	{
		component: 'select-tags',
		name: 'reacao',
		label: 'Reação',
		disabled: false,
		hidden: false,
		handler: 'reasonsHandler',
		// service: 'activeOffer',
		// method: 'getQueueReasons',
		itemLabel: 'name',
		searchAble: true,
		multiple: true,
		options: [],
		returnValue: 'value',
		params: {
			name: 'reasons_id',
			value: null,
		},
		requestOnStart: true,
		alreadyRequested: false,
		loading: false,
	},
	{
		component: 'select-tags',
		name: 'equipe',
		label: 'Equipe',
		disabled: false,
		hidden: false,
		handler: 'teamHandler',
		service: 'team',
		method: 'getAll',
		itemLabel: 'name',
		searchAble: true,
		multiple: false,
		serviceParams: ['', { nocover: true, per_page: 1000 }],
		options: [],
		returnValue: 'id',
		params: {
			name: 'team_id',
			value: null,
		},
		requestOnStart: true,
		alreadyRequested: false,
		loading: false,
	},
	{
		component: 'select-tags',
		name: 'gerente',
		label: 'Gerente',
		disabled: false,
		hidden: false,
		handler: 'managerHandler',
		itemLabel: 'first_name',
		searchAble: true,
		multiple: false,
		options: [],
		returnValue: 'manager_id',
		params: {
			name: 'manager_id',
			value: null,
		},
		requestOnStart: false,
		alreadyRequested: false,
		loading: false,
	},
	{
		component: 'select-tags',
		name: 'corretor',
		label: 'Corretor',
		disabled: false,
		hidden: false,
		handler: 'brokerHandler',
		itemLabel: 'first_name',
		searchAble: true,
		multiple: false,
		options: [],
		returnValue: 'broker_id',
		params: {
			name: 'broker_id',
			value: null,
		},
		requestOnStart: false,
		alreadyRequested: false,
		loading: false,
	},
	{
		component: 'select-tags',
		name: 'status_da_reserva',
		label: "Status da Reserva",
		disabled: false,
		hidden: false,
		handler: 'statusReserveHandler',
		itemLabel: 'item',
		searchAble: true,
		multiple: true,
		options: [
            { item: 'Vendido', value: 'sold', id: 0 },
            { item: 'Reservado', value: 'reserve', id: 1 },
            { item: 'Cancelado', value: 'canceled', id: 2 },
            { item: 'Aguardando', value: 'waiting', id: 3 }
		],
		returnValue: 'value',
		params: {
			name: null,
			value: null
		},
		requestOnStart: false,
		alreadyRequested: false,
		loading: false,
	}
]

const auths = [
    { label: 'Selfie Dinâmica', value: 'liveness' },
    { label: 'Comprovante de Endereço', value: 'address_proof' },
    { label: 'E-mail', value: 'email' },
    { label: 'Biometria Facial', value: 'facial_biometrics' },
    { label: 'Assinatura Manuscrita', value: 'handwritten' },
    { label: 'Certificado Digital', value: 'icp_brasil' },
    { label: 'Pix', value: 'pix' },
    { label: 'Selfie', value: 'selfie' },
    { label: 'SMS', value: 'sms' },
    { label: 'Whatsapp', value: 'whatsapp' }
]

const docuRoles = [
    { label: 'Assinante', value: 'signers' },
    { label: 'Testemunha', value: 'witness' },
    { label: 'Editor', value: 'editors' },
    { label: 'Agente', value: 'agents' },
    { label: 'Em Cópia', value: 'carbonCopies' },
    { label: 'Certificador de Entrega', value: 'certifiedDeliveries' },
    { label: 'Assinante Presencial', value: 'inPersonSigners' },
    { label: 'Intermediário', value: 'intermediaries' },
    { label: 'Notário', value: 'notaryRecipients' },
    { label: 'Selador', value: 'seals' }
]

const types = [
	{ label: 'Assinatura Eletrônica', value: '0' },
	{ label: 'Assinatura Digital', value: '1' },
	{ label: 'Assinatura Presencial', value: '2' }
]

const onlineRoles = [
    { label: 'Assinante', value: '0' },
    { label: 'Aprovador', value: '1' },
    { label: 'Visualizador', value: '2' }
]

const clickRoles = [{
	label: 'Assinante',
	value: 'sign'
}]

const status = [
	// { label: 'Cópia Autorizada', value: 'authoritativecopy' },
	// { label: 'Finalizado', value: 'completed' },
	// { label: 'Correto', value: 'correct' },
	{ label: 'Criado', value: 'created' },
	// { label: 'Recusado', value: 'declined' },
	// { label: 'Removido', value: 'deleted' },
	// { label: 'Entregue', value: 'delivered' },
	{ label: 'Enviado', value: 'sent' },
	// { label: 'Assinado', value: 'signed' },
	// { label: 'Modelo', value: 'template' },
	// { label: 'Expirado', value: 'timedout' },
	// { label: 'Transferência Completa', value: 'transfercompleted' },
	// { label: 'Anulado', value: 'voided' },
]

const onlineDefaultSigners = () => ([
	{
		label: 'Cliente',
		group: 1,
		type: 'customer',
		selected: true,
		role: '0',
		signature_type: '0'
	},
	// {
	// 	label: 'Supervisor',
	// 	group: 2,
	// 	type: 'supervisor',
	// 	selected: false,
	// 	role: '0',
	// 	signature_type: null
	// },
	{
		label: 'Gerente',
		group: 3,
		type: 'manager',
		selected: false,
		role: '0',
		signature_type: null
	},
	{
		label: 'Corretor',
		group: 4,
		type: 'broker',
		selected: false,
		role: '0',
		signature_type: null
	}
])

const docuDefaultSigners = () => ([
	{
		label: 'Cliente',
		group: 1,
		type: 'customer',
		selected: true,
		role: 'signers',
		optional: false,
		keyword: {
			name: '/customer/',
			sign: '/customer_sign/'
		},
	},
	// {
	// 	label: 'Supervisor',
	// 	group: 2,
	// 	type: 'supervisor',
	// 	selected: false,
	// 	role: '',
	//  optional: false,
	// 	keyword: {
	// 		name: '/supervisor/'
	// 	}
	// },
	{
		label: 'Gerente',
		group: 3,
		type: 'manager',
		selected: false,
		role: '',
		optional: false,
		keyword: {
			name: '/manager/'
		}
	},
	{
		label: 'Corretor',
		group: 4,
		type: 'broker',
		selected: false,
		role: '',
		optional: false,
		keyword: {
			name: '/broker/'
		}
	}
])
//[FAS-3993] Comentando o supervisor no objeto default dos assinadores
const clickDefaultSigners = () => ([
	{
		label: 'Cliente',
		group: 1,
		type: 'customer',
		selected: true,
		role: 'sign',
		auth: 'liveness',
		refusable: false,
		communicate_events: {
			signature_request: "email"
		}
	},
	// {
	// 	label: 'Supervisor',
	// 	group: 2,
	// 	type: 'supervisor',
	// 	selected: false,
	// 	role: 'sign',
	// 	auth: 'liveness',
	// 	refusable: false
	// },
	{
		label: 'Gerente',
		group: 3,
		type: 'manager',
		selected: false,
		role: 'sign',
		auth: 'liveness',
		refusable: false,
		communicate_events: {
			signature_request: "email"
		}
	},
	{
		label: 'Corretor',
		group: 4,
		type: 'broker',
		selected: false,
		role: 'sign',
		auth: 'liveness',
		refusable: false,
		communicate_events: {
			signature_request: "email"
		}
	}
])

const orderUserGroups = (list) => {
	const order = ["collaborator", "supervisor", "manager", "broker"];
	const exclude = ["admin", "system"];
	return list.filter(item => !exclude.includes(item.name)).sort((a, b) => {
		const indexA = order.indexOf(a.name);
		const indexB = order.indexOf(b.name);

		if (indexA === -1 && indexB === -1) return 0;
		if (indexA === -1) return 1;
		if (indexB === -1) return -1;

		return indexA - indexB;
	});
}
export {
    auths,
	docuRoles,
	types,
	onlineRoles,
	clickRoles,
	onlineDefaultSigners,
	docuDefaultSigners,
	clickDefaultSigners,
	status,
	orderUserGroups
}